import PubSub from 'pubsub-js';
import WindowStatePlugin from '@/js/plugins/WindowState';

import { MEDIA_QUERIES, TOPIC_IDS } from '@/js/constants';

class CreateWindowState {
  internalState: null | WindowStatePlugin;

  constructor() {
    this.internalState = null;
    this.bind();
  }

  private bind() {
    this.initialize = this.initialize.bind(this);

    if (document.readyState === 'loading') {
      window.addEventListener('DOMContentLoaded', this.initialize);
    } else {
      this.initialize();
    }
  }

  get state() {
    return this.internalState?.state;
  }

  private initialize() {
    this.internalState = new WindowStatePlugin({
      target: window,
      breakpoints: [
        {
          id: 'mobile',
          query: MEDIA_QUERIES.MOBILE,
        },
        {
          id: 'desktop',
          query: MEDIA_QUERIES.DESKTOP,
        },
      ],
      on: {
        // load: (state) => {
        //   PubSub.publish("App.load", state);
        // },
        // scroll: (state) => {
        // },
        // resize: (state) => {
        // },
        changeBreakpoint: (state) => {
          PubSub.publish(TOPIC_IDS.WINDOW_CHANGE_BREAKPOINT, state);
        },
      },
    });
  }
}

// Singleton
export const windowState = new CreateWindowState();
